import { DollhouseProvider } from '@spazious/dollhouse-engine';

import { StoreContext } from './StoreContext.js';
import { Store } from './types.js';

export interface StoreProviderProps {
  store: Store;
  children: React.ReactNode;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ children, store }) => {
  return (
    <StoreContext.Provider value={store}>
      <DollhouseProvider store={store.dollhouse}>{children}</DollhouseProvider>
    </StoreContext.Provider>
  );
};
